// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import RegisterLogin from "./pages/RegisterLogin";
import VerifyEmail from "./pages/VerifyEmail";      // ✅ 新增：邮箱验证码页面

import DashboardPage from './pages/DashboardPage';
import SPTComparison from './pages/SPTComparison';
import VisualizeSimulation from './pages/VisualizeSimulation';

import TrainingControl from './components/TrainingControl';
import SimulationDashboard from "./components/SimulationDashboard";
import HistoryPage from './pages/HistoryPage';
import ExplorePage from './pages/ExplorePage';
import UploadPage from './pages/UploadPage';
import TrackMatePage from './pages/sptalgorithms/TrackMatePage';
import DeepTrackPage from "./pages/sptalgorithms/DeepTrackPage";
import TrainingDashboard from './pages/TrainingDashboard';

import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <Router>
      {/* 如果你想在任何页面都能弹 toast，可以放一个 ToastContainer */}
      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>
        {/* 默认跳到注册/登录页 */}
        <Route path="/" element={<Navigate to="/register" />} />

        {/* 注册 + 登录合并页面 */}
        <Route path="/register" element={<RegisterLogin />} />

        {/* ✅ 新增：邮箱验证码验证页面 */}
        <Route path="/verify" element={<VerifyEmail />} />

        {/* 仪表盘 & 其他功能页 */}
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/compare" element={<SPTComparison />} />

        <Route path="/training" element={<TrainingControl />} />
        <Route path="/simulate" element={<SimulationDashboard />} />
        <Route path="/simulationdatavisualize" element={<VisualizeSimulation />} />

        <Route path="/history" element={<HistoryPage />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/upload" element={<UploadPage />} />

        <Route path="/train" element={<TrainingDashboard />} />

        {/* 算法页面 */}
        <Route path="/trackmate" element={<TrackMatePage />} />
        <Route path="/deeptrack" element={<DeepTrackPage />} />

        {/* 兜底 404 */}
        <Route
          path="*"
          element={
            <div style={{ textAlign: 'center', marginTop: '40px' }}>
              404 - Webpage Doesn&apos;t Exist
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
